/**
 * Notification Service
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.3.9
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ContactRequest { 
    company?: string;
    subject?: string;
    deliveryDate?: string;
    contactName?: string;
    emailFrom?: string;
    phone?: string;
    message?: string;
    reseller?: ContactRequest.ResellerEnum;
}
export namespace ContactRequest {
    export type ResellerEnum = 'SETTE' | 'OTTO' | 'TENDERI';
    export const ResellerEnum = {
        SETTE: 'SETTE' as ResellerEnum,
        OTTO: 'OTTO' as ResellerEnum,
        TENDERI: 'TENDERI' as ResellerEnum
    };
}